export const TickerBar = ({ ticker }) => (
  <div className="ticker-bar" data-testid="hero-ticker">
    <div className="ticker-track">
      {ticker.length === 0 ? (
        <span className="ticker-item" style={{ color: "var(--muted)" }}>Loading live market data…</span>
      ) : (
        [...ticker, ...ticker].map((t, i) => (
          <span key={`${t.sym}-${i}`} className="ticker-item">
            <span className="ticker-sym">{t.sym}</span>
            {t.price ? (
              <>
                <span className="ticker-price">₹{t.price}</span>
                <span className={`ticker-chg ${t.dir}`}>
                  {t.dir === "up" ? "▲" : "▼"} {t.chg}
                </span>
              </>
            ) : (
              <span className="ticker-price" style={{ color: "var(--muted)" }}>Unavailable</span>
            )}
          </span>
        ))
      )}
    </div>
  </div>
);
